import { MessageBarType } from "@fluentui/react";
import { useState } from "react";
import { IDataResult, IResult, ResponseStatus } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { SocialAccountModel, SocialAccountType } from "../models/SocialAccountModel";
import { CustomerAccountService } from "../services/CustomerAccountService";

export function useCustomerAccountVM() {
    const service = new CustomerAccountService();

    const [accounts, setAccounts] = useState<SocialAccountModel[]>([]);
    const [listHash, setListHash] = useState<number>(0);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [showEntry, setShowEntry] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const {
        form,
        setForm,
        resetForm,
        setField,
        errorMessages,
        setErrorMessages,
        summaryText,
        setSummaryText,
        summaryType,
        setSummaryType
    } = useForm<SocialAccountModel>({
        id: 0,
        type: SocialAccountType.facebook,
        name: "",
        url: "",
        isPrimary: false
    });

    const getList = () => {
        setLoading(true);
        setAccounts([]);
        setListHash(Utils.getRandomKey());

        const request = service.getList();
        DataUtils.onRequest(request, onGetListResult);
    }

    const onGetListResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success && result.data) {
            const accounts = result.data as SocialAccountModel[];
            setAccounts(accounts);
            setListHash(Utils.getRandomKey());
        }

        setLoading(false);
    }

    const create = () => {
        setSubmitting(true);
        const request = service.create(form);
        DataUtils.onRequest(request, onSubmitResult);
    }

    const edit = () => {
        setSubmitting(true);
        const request = service.edit(form);
        DataUtils.onRequest(request, onSubmitResult);
    }

    const onSubmitResult = (result: IDataResult) => {
        if (!result.errorMessages) result.errorMessages = {};

        if (result.status === ResponseStatus.success) {
            setShowEntry(false);
            setIsEdit(false);
            getList();
        }

        setSubmitting(false);

        const res = result as IResult
        if (res) { setErrorMessage(res); }
    }

    const del = (id: number) => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setShowDelete(false);
                getList();
            }

            setSubmitting(false);
        }

        setSubmitting(true);
        const request = service.delete(id);
        DataUtils.onRequest(request, onResult);
    }

    const setErrorMessage = (result: IResult) => {
        setErrorMessages(result.errorMessages);
        setSummaryText(result.summaryText ?? "");
        setSummaryType(result.summaryType ?? MessageBarType.info);
    }

    return {
        accounts,

        form,
        setForm,
        resetForm,
        setField,
        errorMessages,

        loading,
        setLoading,

        submitting,
        setSubmitting,

        showEntry,
        setShowEntry,

        showDelete,
        setShowDelete,

        isEdit,
        setIsEdit,

        getList,
        create,
        edit,
        del,

        listHash
    }
}